import React from "react";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { Box, Card, CardActions, CardContent, Grid, IconButton, Typography } from "@mui/material";
import Button from "components/ui/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import custumTheme from "thems/catalogueCardThems";
import { ReactComponent as ActiveLogIcon } from "assets/icons/CatalogueCard/active_log.svg";
import { ReactComponent as EditIcon } from "assets/icons/CatalogueCard/edit.svg";
import { ReactComponent as ViewIcon } from "assets/icons/CatalogueCard/eye.svg";
import { ReactComponent as LinkIcon } from "assets/icons/CatalogueCard/link.svg";
import { ReactComponent as RingIcon } from "assets/icons/CatalogueCard/ring.svg";
import "../styles/catalogueCard.css";
import { useLocation, useNavigate } from "react-router-dom";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import profileImage from "../../../assets/img/profile.png";
import SortContext from "context/SortContext";
import { ReactComponent as MyBinnysLogo } from "assets/catalogSetting/myBinnysLogo.svg";
import { ReactComponent as Setting } from "assets/sidebar/enable/setting.svg";

const icons = [
  {
    iconId: 1,
    svgIcon: <RingIcon className="catalogue-card-logo" />,
  },
  {
    iconId: 2,
    svgIcon: <LinkIcon className="catalogue-card-logo" />,
  },
  {
    iconId: 3,
    svgIcon: <ViewIcon className="catalogue-card-logo" />,
  },
];

function CatalogueCard({ item, handleButtonClick, infoClick }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  const permission = usePermissions();
  const shareCatalogView = hasAccessPage(findSpecificPage("Catalog", permission), "edit");
  // const hasAccessVieCatalogActivity = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog", permission), "Catalog Activity"), "view");
   const hasAccessVieCatalogActivity = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Activity"), "view");
  const hasAccessEditCatalog = hasAccessPage(findSpecificPage("Catalog", permission), "edit");
  const hasAccessAddArchiveCatalog = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Archives"), "add");
  const hasAccessCatalogSetting = hasAccessPage(findSpecificPage("Catalog Setting", permission), "view");
  let preState = location.state;
  const { search } = React.useContext(SortContext);

  const handleCardClick = (isArchive) => {
    let state;
    if (isArchive) {
      let existingName = [location?.state?.name[0], location?.state?.name[1]];

      state = {
        ...preState,
        name: [...existingName, `${item.number} (${item.subname})`],
      };

      navigate(`/Setting/archives/Catalog/${item.id}`, { state });
    } else {
      let numb = typeof item.numberOfStyles === "number" && item.numberOfStyles < 10 ? `0${item.numberOfStyles}` : `${item.numberOfStyles}`;

      let catalogNumberAndCount = encodeURIComponent(`${item.number} (${item.subname}) - ${numb}`);
      if (location?.state?.newName === "Create Order") {
        // state = { ...location?.state, name: [`${item.number} (${item.subname}) - ${numb}`] };
        state = { ...location?.state, name: [`${item.number} (${item.subname})`] };
      } else {
        state = {
          view: false,
          // name: [`${item.number} (${item.subname}) - ${numb}`],
          name: [`${item.number} (${item.subname})`],
          catalogSearch: search !== "" ? search : "",
        };
      }

      navigate(`/Catalog/${item.id}?catalogNumberAndCount=${catalogNumberAndCount}`, { state });
    }
  };

  const buttons = [
    {
      btnId: 1,
      title: "Share Link",
      view: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog", permission), "Share Catalog"), "view"),
      add: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog", permission), "Share Catalog"), "add"),
    },
    {
      btnId: 2,
      title: "Share to",
      // view: hasAccessPage(findSpecificPage("Catalog Setting", permission), "view"),
      view: true,
    },
  ];

  const unArchivesbuttons = [
    {
      btnId: 1,
      title: "Delete",
      style: { color: "#E77B7B", fontSize: "18px", border: "1px solid #E77B7B" },
      // view: hasAccessPage(findSpecificPage("Catalog", permission), "archive"),
      view: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Archives"), "archive"),
    },
    {
      btnId: 2,
      title: "Unarchive",
      style: { color: "#50C878", fontSize: "18px", border: "1px solid #50C878" },
      // view: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Archives"), "add"),
      view: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Archives"), "edit"),
    },
  ];

  return (
    <>
      <ThemeProvider theme={custumTheme} key={"catalogue" + item.id}>
        <Grid item key={"catalogue-grid" + item.id}>
          <Card key={"catalogue-card" + item.id} sx={{ padding: "12px", maxWidth: "433px", minWidth: "433px", cursor: "pointer" }} onClick={() => handleCardClick(item.isArchive)}>
            <CardContent sx={{ padding: "0px" }}>
              <Box className={`catalague-card-flex-between-center ${isSmallScreen ? "catalague-card-flexDirection-column" : "catalague-card-flexDirection-row"} catalague-card-witdh-100`}>
                <Box className={`catalague-card-flex-between-center ${isSmallScreen ? "catalague-card-witdh-100" : "catalague-card-witdh-auto"}`}>
                  <Typography className="catelogue-card-subheading" mr={1}>
                    {item.subname?.length > 20 ? item.subname.slice(0, 22) + "...." : item.subname}
                  </Typography>
                  <Typography className="catelogue-card-number">({item.number})</Typography>
                </Box>
                {item.isArchive ? (
                  ""
                ) : (
                  <Box
                    className={`${isSmallScreen ? "catalague-card-witdh-100" : hasAccessVieCatalogActivity && hasAccessEditCatalog ? "catalague-card-witdh-20" : ""}`}
                    mt={isSmallScreen ? 1 : 0}
                    mb={isSmallScreen ? 1 : 0}
                  >
                    <Grid
                      container
                      className="catalague-card-flex-between-center catalague-card-witdh-100"
                      sx={{ display: "flex", justifyContent: "end !important", flexWrap: "nowrap", columnGap: "16px" }}
                    >
                      {hasAccessVieCatalogActivity && (
                        <Grid item xs={6} sm={4} className={`${isSmallScreen ? "catalague-card-flex-center-center" : "catalague-card-flex-between-center"}`}>
                          <IconButton sx={{ p: 0 }} size="large" color="inherit" className="btn" onClick={(e) => handleButtonClick(item, "ActiveLog", e)} disableRipple disableFocusRipple>
                            <ActiveLogIcon className="catalogue-card-logo" />
                          </IconButton>
                        </Grid>
                      )}
                      {hasAccessEditCatalog && (
                        <Grid item xs={6} sm={4} className={`${isSmallScreen ? "catalague-card-flex-center-center" : "catalague-card-flex-between-center"}`}>
                          <IconButton sx={{ p: 0 }} size="large" color="inherit" className="btn" onClick={(e) => handleButtonClick(item, "EditCatalogue", e)} disableRipple disableFocusRipple>
                            <EditIcon className="catalogue-card-logo" />
                          </IconButton>
                        </Grid>
                      )}
                      {hasAccessCatalogSetting && (
                        <Grid item xs={6} sm={4} className={`${isSmallScreen ? "catalague-card-flex-center-center" : "catalague-card-flex-between-center"}`}>
                          <IconButton sx={{ p: 0 }} size="large" color="inherit" className="btn" onClick={(e) => handleButtonClick(item, "Settings", e)} disableRipple disableFocusRipple>
                            <Setting className="catalogue-card-logo" />
                          </IconButton>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                )}
              </Box>
              <Box>
                <Grid container className={`${isSmallScreen ? "catalague-card-witdh-100" : "catalague-card-witdh-50"}`} pl={isSmallScreen ? 0 : 0.5} mt={1}>
                  {icons.map((icon, index) => {
                    let countValue = item.iconsData[index].count;
                    return (
                      <Grid
                        key={icon.iconId}
                        item
                        xs={"16px"}
                        sm={"16px"}
                        gap={0.35}
                        className="catalague-card-flex-between-center"
                        sx={{
                          ml: index === 0 ? 0 : "10px",
                        }}
                      >
                        <Box className="catalague-card-flex-align-center">{icon.svgIcon}</Box>
                        <Typography className="catalogue-card-count">{countValue}</Typography>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
              <Box textAlign={isSmallScreen ? "left" : "right"} mt={2}>
                <div className="" onClick={infoClick}>
                  <Typography className="catalogue-card-owner catalague-card-flex-end-center">
                    {item.owner}
                    <img src={item.profile ? item.profile : profileImage} alt={profileImage} style={{ width: "20px", height: "20px", borderRadius: "40px", marginLeft: "12px" }} />
                  </Typography>
                </div>
              </Box>
            </CardContent>
            {!item.isArchive ? (
              <CardActions
                sx={{
                  gap: isSmallScreen ? 0 : 3.5,
                  padding: "0px",
                  paddingTop: buttons.some((btn) => btn.view) && "12px",
                  mt: 0.5,
                }}
              >
                {buttons
                  .filter((btn) => btn.view)
                  .map((btn) => (
                    <Button
                      key={`btn${btn.btnId}${item.id}`}
                      disabled={Object.keys(btn).includes("add") ? !btn.add : false}
                      variant="contained"
                      fullWidth
                      disableElevation
                      onClick={(e) => handleButtonClick(item, btn.title, e)}
                    >
                      {/* {btn.title} */}
                      {btn.title === "Share to" ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "0.15vw" }}>
                          {btn.title}{" "}
                          <div>
                            <MyBinnysLogo width={"1.7vw"} height={"1.25vw"} />
                          </div>
                        </div>
                      ) : (
                        btn.title
                      )}
                    </Button>
                  ))}
              </CardActions>
            ) : (
              <CardActions
                sx={{
                  gap: isSmallScreen ? 0 : 3.5,
                  padding: "0px",
                  paddingTop: hasAccessAddArchiveCatalog && "12px",
                  mt: 0.5,
                }}
              >
                {unArchivesbuttons
                  .filter((btn) => btn.view)
                  .map((btn) => (
                    <Button sx={btn.style} key={`btn${btn.btnId}${item.id}`} variant="contained" fullWidth disableElevation onClick={(e) => handleButtonClick(item, btn.title, e)}>
                      {btn.title}
                    </Button>
                  ))}
                {/* {hasAccessAddArchiveCatalog && (
                  <Button sx={{ color: "#E77B7B", fontSize: "18px", border: "1px solid #E77B7B" }} variant="contained" fullWidth disableElevation onClick={(e) => handleButtonClick(item, e)}>
                    Delete
                  </Button>
                )}
                {hasAccessAddArchiveCatalog && (
                  <Button sx={{ color: "#50C878", fontSize: "18px", border: "1px solid #50C878" }} variant="contained" fullWidth disableElevation onClick={(e) => handleButtonClick(item, e)}>
                    Unarchive
                  </Button>
                )} */}
              </CardActions>
            )}
          </Card>
        </Grid>
      </ThemeProvider>
    </>
  );
}

export default CatalogueCard;
